import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  addP2p,
  deleteP2p,
  editP2p,
  getCoin,
  getCurrency,
  getP2p,
  getP2pById,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft, FaPlus } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import ReactSelect from "react-select";
import { sanitizeInput } from "../../../config/validation";
import { triggerDownload } from "../../../config/downloadUtils";
import moment from "moment";

const formatDate = (val) => (val ? moment(val).format("DD/MM/YYYY") : "-");

const ALL_COLUMNS = [
  {
    key: "coin",
    title: "Coin Name",
    defaultVisible: true,
    render: (r) => r?.coin?.name || "-",
  },
  {
    key: "symbol",
    title: "Symbol",
    defaultVisible: false,
    render: (r) => r?.coin?.symbol || "-",
  },
  {
    key: "fiatPairs",
    title: "Fiat P2P",
    defaultVisible: true,
    render: (r) =>
      Array.isArray(r?.fiatPairs) && r.fiatPairs.length > 0
        ? r.fiatPairs.map((obj) => obj?.fiatName).join(", ")
        : "-",
  },
  {
    key: "isEnabledForP2P",
    title: "P2P supported",
    defaultVisible: true,
    render: (r) =>
      r?.isEnabledForP2P === true
        ? "Yes"
        : r?.isEnabledForP2P === false
          ? "No"
          : "-",
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDate(r?.createdAt),
  },
];

const p2pStatusOptions = [
  { label: "Enabled", value: "true" },
  { label: "Disabled", value: "false" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
  indicatorSeparator: () => ({ display: "none" }),
};

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const P2ppair = () => {
  const [roleInput, setroleInput] = useState({
    name: "",
    Pair: [],
  });

  const [pair, setPair] = useState({
    currency: "",
    isEnabledForP2P: "",
    minP2PAmount: "",
    maxP2PAmount: "",
  });

  const [roleInputError, setroleInputError] = useState({
    name: false,
    isEnabledForP2P: false,
    Pair: false,
  });
  const [currencyList, setCurrencyList] = useState([]);
  const [pairList, setPairList] = useState([]);
  const [coinList, setCoinList] = useState([]);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCoin, setFilterCoin] = useState(null);
  const [filterEnabled, setFilterEnabled] = useState(null);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "p2p-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    const { name, value } = e.target;
    setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
    setroleInputError({ ...roleInputError, [name]: false });
  };

  const getCurrencyList = () => {
    let body = {
      page: page,
      sizePerPage: 10,
      pagination: false,
    };

    setLoading(true);
    getCurrency(body)
      .then((res) => {
        if (res?.status) {
          setCurrencyList(res?.data?.result);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleAdd = () => {
    if (Number(pair.minP2PAmount) > Number(pair.maxP2PAmount)) {
      toast.warn("Min amount can't be larger than Max amount");
      return;
    }

    if (roleInput?.Pair?.some((obj) => obj?.currency === pair.currency)) {
      toast.warn("Currency already included");
      return;
    }

    if (pair.currency && pair.minP2PAmount && pair.maxP2PAmount) {
      setroleInput((prevState) => ({
        ...prevState,
        Pair: [...(prevState.Pair || []), pair],
      }));

      setPair({
        currency: "",
        minP2PAmount: "",
        maxP2PAmount: "",
      });
    } else {
      toast.warn("Please fill out all fields before adding.");
    }
  };

  const handleDelete = (index) => {
    const updatedPairs = roleInput.Pair.filter((_, i) => i !== index);
    setroleInput({
      ...roleInput,
      Pair: updatedPairs,
    });
  };

  const getCoinList = () => {
    let body = {
      page: page,
      sizePerPage: 10,
      pagination: false,
    };

    setLoading(true);
    getCoin(body)
      .then((res) => {
        if (res?.status) {
          setCoinList(res?.data?.result);
          // dispatch(actions.setUserList(res?.data?.result));
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  const getPairList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (filterCoin) {
      body.coin = filterCoin?.value;
    }
    if (filterEnabled) {
      body.isEnabledForP2P = filterEnabled?.value === "true";
    }

    setLoading(true);
    getP2p(body)
      .then((res) => {
        if (res?.status) {
          setPairList(res?.data);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    if (filterCoin) body.coin = filterCoin?.value;
    if (filterEnabled) body.isEnabledForP2P = filterEnabled?.value === "true";
    setDownloadLoading(true);
    getP2p(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "p2p");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleClear = () => {
    setroleInput({
      ...roleInput,
      name: "",
      Pair: [],
      isEnabledForP2P: "",
    });
    setroleInputError({
      name: false,
      Pair: false,
      isEnabledForP2P: false,
    });
  };
  // ADD USER FUNCTION
  const addUserFun = () => {
    if (!roleInput?.name) {
      setroleInputError({ ...roleInputError, name: true });
      toast.error("Please Select coin", { toastId: 'p2p-validation-error' });
      return;
    }
    if (
      roleInput?.isEnabledForP2P === undefined ||
      roleInput?.isEnabledForP2P === null ||
      typeof roleInput?.isEnabledForP2P !== "boolean"
    ) {
      setroleInputError({ ...roleInputError, isEnabledForP2P: true });
      toast.error("Please Select P2P Enable", { toastId: 'p2p-validation-error' });
      return;
    }

    if (!roleInput?.Pair || roleInput?.Pair?.length === 0) {
      setroleInputError({ ...roleInputError, Pair: true });
      toast.error("Please Select at least one pair", { toastId: 'p2p-validation-error' });
      return;
    }

    if (roleInput) {
      setLoading(true);
      if (!edit) {
        const body = {
          coin: roleInput?.name,
          fiatPairs: roleInput?.Pair.map((pair) => ({
            fiatCurrency: pair.currency,
            minP2PAmount: parseFloat(pair.minP2PAmount),
            maxP2PAmount: parseFloat(pair.maxP2PAmount),
          })),
          isEnabledForP2P: roleInput?.isEnabledForP2P,
        };
        addP2p(body)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'p2p-add-success' });
              setUser(false);
              getPairList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'p2p-add-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'p2p-add-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      } else {
        const body = {
          // coin: roleInput?.name,
          fiatPairs: roleInput?.Pair.map((pair) => ({
            fiatCurrency: pair.currency,
            minP2PAmount: parseFloat(pair.minP2PAmount),
            maxP2PAmount: parseFloat(pair.maxP2PAmount),
          })),
          isEnabledForP2P: roleInput?.isEnabledForP2P,
        };
        editP2p(id?._id, body)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'p2p-update-success' });
              setEdit(false);
              setUser(false);
              getPairList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'p2p-update-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'p2p-update-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      }
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteP2p(id?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'p2p-delete-success' });
          handleCloseDelete();
          getPairList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'p2p-delete-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'p2p-delete-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCurrencyList();
    getCoinList();
    getPairList();
  }, [page]);

  const getCurrencyDataById = (id) => {
    getP2pById(id)
      ?.then((res) => {
        if (res?.status) {
          let data = res?.data;
          let pair = [];
          data?.fiatPairs &&
            data?.fiatPairs?.length > 0 &&
            data?.fiatPairs?.map((obj) =>
              pair.push({
                currency: obj?.fiatCurrency,
                minP2PAmount: obj?.minP2PAmount,
                maxP2PAmount: obj?.maxP2PAmount,
              })
            );
          setroleInput({
            ...roleInput,
            Pair: pair,
            name: data?.coin?._id,
            isEnabledForP2P: data?.isEnabledForP2P,
          });
        }
      })
      .catch((e) => {});
  };

  const columns2 = [
    {
      title: "Coin Name",
      dataIndex: "coin",
      render: (row) => <div>{`${row?.name}`}</div>,
    },

    {
      title: "Fiat P2P",
      dataIndex: "fiatPairs",
      render: (row) => <div>{`${row?.map((obj) => obj?.fiatName)} `}</div>,
    },
    {
      title: "P2P supported",
      dataIndex: "isEnabledForP2P",
      render: (row) => <div>{`${row} `}</div>,
    },

    {
      title: "Date",
      dataIndex: "createdAt",
      render: (row) => <div>{`${moment(row).format("DD/MM/YYYY")} `}</div>,
      // sorter: (a, b) => a.role.length - b.role.length,
    },

    {
      title: "Action",
      className: "text-end",
      render: (row) => (
        <div className="text-end">
          <a
            className="me-1 btn btn-sm bg-success-light "
            onClick={() => {
              setId(row);

              handleClear();
              setUser(true);
              setEdit(true);
              getCurrencyDataById(row?._id);
            }}
          >
            <i className="fe fe-pencil"></i> Edit
          </a>

          {/* {permission &&
            permission?.length > 0 &&
            permission?.find((module) => module.module === "User")?.delete && ( */}
          <a
            onClick={() => {
              handleOpenDelete(), setId(row);
            }}
            className="me-1 btn btn-sm bg-danger-light"
          >
            <i className="fe fe-trash"></i> Delete
          </a>
          {/* )} */}
        </div>
      ),
      sorter: (a, b) => a.length - b.length,
    },
  ];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">P2P Pairs</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">P2P Pairs</li>
                </ul>
              </div>
              {!user && (
                <div className="col-sm-5 col">
                  <a
                    onClick={() => {
                      handleClear(), setEdit(false), setUser(true);
                    }}
                    data-bs-toggle="modal"
                    className="btn btn-primary float-end mt-2"
                  >
                    Add P2P Pairs
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false), setUser(false);
                        }}
                      />
                      <h4>{edit ? "Edit P2P Pairs" : "Add P2P Pairs"}</h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={addUserFun}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Coin &nbsp;
                        {roleInputError?.name && (
                          <small style={{ color: "red" }}>
                            {"Coin is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.name}
                        onChange={roleChange}
                        disabled={edit}
                        name="name"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        {coinList &&
                          coinList?.length > 0 &&
                          coinList?.map((item, _id) => {
                            return (
                              <MenuItem
                                key={_id}
                                style={{ height: "50px" }}
                                value={item?._id}
                              >
                                {item?.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        P2P Enable &nbsp;
                        {roleInputError?.isEnabledForP2P && (
                          <small style={{ color: "red" }}>
                            {"P2P is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.isEnabledForP2P}
                        onChange={roleChange}
                        name="isEnabledForP2P"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        <MenuItem style={{ height: "50px" }} value={true}>
                          Yes
                        </MenuItem>
                        <MenuItem style={{ height: "50px" }} value={false}>
                          No
                        </MenuItem>
                      </Select>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Currency List &nbsp;
                        {roleInputError?.name && (
                          <small style={{ color: "red" }}>
                            {"Currency List is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={pair?.currency}
                        onChange={(e) =>
                          setPair({ ...pair, currency: e.target.value })
                        }
                        name="name"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        {currencyList &&
                          currencyList?.length > 0 &&
                          currencyList?.map((item, _id) => {
                            return (
                              <MenuItem
                                key={_id}
                                style={{ height: "50px" }}
                                value={item?._id}
                              >
                                {item?.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Min Amount&nbsp;
                        {roleInputError?.symbol && (
                          <small style={{ color: "red" }}>
                            {"Min Amount is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="number"
                        placeholder="Min P2PAmount "
                        value={pair?.minP2PAmount}
                        onChange={(e) => {
                          const value = +sanitizeInput(e.target.value);
                          if (value >= 0) {
                            setPair({ ...pair, minP2PAmount: value });
                          }
                        }}
                        name="minP2PAmount"
                        id="minP2PAmount"
                        inputProps={{ min: 0 }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      <div>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ marginLeft: "7px" }}
                        >
                          Max Amount&nbsp;
                          {roleInputError?.symbol && (
                            <small style={{ color: "red" }}>
                              Max is required
                            </small>
                          )}
                        </InputLabel>
                        <TextField
                          variant="outlined"
                          style={{
                            marginLeft: "5px",
                            height: "100%",
                            width: "300px",
                          }}
                          className="form-control"
                          type="number"
                          placeholder="Max P2PAmount"
                          value={pair?.maxP2PAmount}
                          onChange={(e) => {
                            const value = +sanitizeInput(e.target.value);
                            if (value >= 0) {
                              setPair({ ...pair, maxP2PAmount: value });
                            }
                          }}
                          name="maxP2PAmount"
                          id="maxP2PAmount"
                          inputProps={{ min: 0 }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "+" ||
                              e.key === "e" ||
                              e.key === "E"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "8px",
                          border: "2px solid grey",
                          height: "56px",
                          width: "56px",
                          cursor: "pointer",
                          marginTop: "20px",
                        }}
                        onClick={() => handleAdd()}
                      >
                        <FaPlus />
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {roleInput.Pair && roleInput.Pair.length > 0 && (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Currency
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Min Amount
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Max Amount
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {roleInput?.Pair?.map((p, index) => (
                            <tr key={index}>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {currencyList.find(
                                  (item) => item._id === p.currency
                                )?.name || p.currency}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {/* {p.minP2PAmount} */}
                                <input
                                  type="number"
                                  placeholder="amount"
                                  value={p.minP2PAmount}
                                  min="0"
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "-" ||
                                      e.key === "+" ||
                                      e.key === "e" ||
                                      e.key === "E"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    const updatedValue =
                                      +sanitizeInput(e.target.value) < 0
                                        ? 0
                                        : +sanitizeInput(e.target.value);
                                    if (p.maxP2PAmount < +updatedValue) {
                                      toast.error(
                                        "Min amount can't be more than Max amount",
                                        { toastId: 'p2p-error' }
                                      );
                                      return;
                                    }
                                    setroleInput((prev) => ({
                                      ...prev,
                                      Pair: prev.Pair.map((pair, idx) =>
                                        idx === index
                                          ? {
                                              ...pair,
                                              minP2PAmount: updatedValue,
                                            }
                                          : pair
                                      ),
                                    }));
                                  }}
                                />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {/* {p.maxP2PAmount} */}
                                <input
                                  type="number"
                                  placeholder="amount"
                                  value={p.maxP2PAmount}
                                  min="0"
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "-" ||
                                      e.key === "+" ||
                                      e.key === "e" ||
                                      e.key === "E"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    const updatedValue =
                                      +sanitizeInput(e.target.value) < 0
                                        ? 0
                                        : +sanitizeInput(e.target.value);
                                    if (p.minP2PAmount > +updatedValue) {
                                      toast.error(
                                        "Max amount can't be less than Min amount",
                                        { toastId: 'p2p-error' }
                                      );
                                      return;
                                    }
                                    setroleInput((prev) => ({
                                      ...prev,
                                      Pair: prev.Pair.map((pair, idx) =>
                                        idx === index
                                          ? {
                                              ...pair,
                                              maxP2PAmount: updatedValue,
                                            }
                                          : pair
                                      ),
                                    }));
                                  }}
                                />
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                <button
                                  onClick={() => handleDelete(index)}
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                    padding: "5px 10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <div className="card">
                    <div className="col-12 col-sm-8 col-md-6 text-sm-end"></div>
                    <div className="card-body">
                      <TableToolbar
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageSizeOptions={pageSizeOptions}
                        total={pairList?.total}
                        page={page}
                        visibleColumnKeys={visibleColumnKeys}
                        allColumns={ALL_COLUMNS}
                        toggleColumn={toggleColumn}
                        resetColumns={resetColumns}
                        onDownload={handleDownload}
                        downloadLoading={downloadLoading}
                      />
                      <div className="table-responsive">
                        {" "}
                        {loading ? (
                          <div className="his-spin">
                            {" "}
                            <Spin
                              size="large"
                              style={{ position: "relative", top: "35%" }}
                            />
                          </div>
                        ) : (
                          <Table
                            pagination={false}
                            // pagination={{
                            //   total: currencyList.length,
                            //   showTotal: (total, range) =>
                            //     `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            //   showSizeChanger: true,
                            //   onShowSizeChange: onShowSizeChange,
                            //   itemRender: itemRender,
                            // }}
                            style={{ overflowX: "auto" }}
                            columns={columns2}
                            dataSource={pairList ? pairList?.result : []}
                            rowKey={(record) => record.id}
                          />
                        )}
                        {pairList && pairList?.total > 10 && (
                          <CustomPagination
                            totalTabs={pairList?.total}
                            tabsPerPage={10}
                            handleChange={setPage}
                            className={`${
                              loading ? "display-hide" : "display-flex"
                            }`}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default P2ppair;
